import React from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { accountManagementBulkAdminAccessControl } from '../access-control/accountManagementBulkAdminAccess.configuration'

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const accountManagementBulkAdminRouter = (
  <DomainRoute
    route="app-admin-account-management-bulk"
    accessControl={accountManagementBulkAdminAccessControl}
  >
    <DashSwitch>
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
